import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

function TooltipProvider({
  delayDuration = 0,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  )
}

function Tooltip({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  )
}

function TooltipTrigger({
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

function TooltipContent({
  className,
  sideOffset = 0,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        collisionPadding={{ top: 8, right: 320, bottom: 8, left: 8 }}
        avoidCollisions={true}
          className={cn(
          "cy:bg-[#2E3240] cy:text-primary-foreground cy:animate-in cy:fade-in-0 cy:zoom-in-95 cy:data-[state=closed]:animate-out cy:data-[state=closed]:fade-out-0 cy:data-[state=closed]:zoom-out-95 cy:data-[side=bottom]:slide-in-from-top-2 cy:data-[side=left]:slide-in-from-right-2 cy:data-[side=right]:slide-in-from-left-2 cy:data-[side=top]:slide-in-from-bottom-2 cy:z-[9999] cy:max-w-xs cy:w-fit cy:origin-(--radix-tooltip-content-transform-origin) cy:rounded-md cy:px-3 cy:py-1.5 cy:text-xs cy:break-words cy:whitespace-normal",
          className
        )}
        style={{
          maxWidth: 'min(calc(100vw - 16px), 20rem)',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          ...props.style,
        }}
        {...props}
      >
        {children}
        <TooltipPrimitive.Arrow 
          className="cy:fill-[#2E3240]" 
          width={11} 
          height={5}
          style={{
            transform: 'translateY(-2.5px)',
          }}
        />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
